import React from 'react';
import { Link } from 'react-router-dom';
import { FaShare, FaEnvelope, FaEdit, FaTrash, FaUsers, FaHome } from 'react-icons/fa';

/**
 * Event-specific navigation items
 */
export function EventNavItems({ event, family, eventActions }) {
  const { onShare, onInvite, onEdit, onDelete, canEdit } = eventActions || {};

  return (
    <div className="flex items-center flex-wrap gap-2">
      {/* Share Button */}
      <button
        onClick={onShare}
        className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-green-700 bg-green-50 hover:bg-green-100 rounded-lg transition text-xs sm:text-sm"
        data-testid="share-event-btn"
      >
        <FaShare className="text-sm" />
        <span>Share</span>
      </button>

      {/* Send Invites Button */}
      <button
        onClick={onInvite}
        className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-purple-700 bg-purple-50 hover:bg-purple-100 rounded-lg transition text-xs sm:text-sm"
        data-testid="invite-event-btn"
      >
        <FaEnvelope className="text-sm" />
        <span className="hidden sm:inline">Send Invites</span>
        <span className="sm:hidden">Invites</span>
      </button>

      {/* Edit Button - Only if user can edit */}
      {canEdit && (
        <>
          <button
            onClick={onEdit}
            className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-lg transition text-xs sm:text-sm"
            data-testid="edit-event-btn"
          >
            <FaEdit className="text-sm" />
            <span>Edit</span>
          </button>
          <button
            onClick={onDelete}
            className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-red-700 bg-red-50 hover:bg-red-100 rounded-lg transition text-xs sm:text-sm"
            data-testid="delete-event-btn"
          >
            <FaTrash className="text-sm" />
            <span>Delete</span>
          </button>
        </>
      )}

      {/* Back to Family Link */}
      {family && (
        <Link
          to={`/family/${family.family_id || event?.family_id}`}
          className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-amber-700 bg-amber-50 hover:bg-amber-100 rounded-lg transition text-xs sm:text-sm"
          data-testid="back-to-family-link"
        >
          <FaUsers className="text-sm" />
          <span>{family.name || 'Family'}</span>
        </Link>
      )}

      {/* Home Link */}
      <Link
        to="/"
        className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 rounded-lg transition text-xs sm:text-sm"
        data-testid="home-link"
      >
        <FaHome className="text-sm" />
        <span>Home</span>
      </Link>
    </div>
  );
}
